export default __webpack_public_path__ + "static/media/out_4.7fefd892.jpg";